export const getToken = () => JSON.parse(localStorage.getItem("user"))?.token;

export const setToken = (token) => {
  const userObject = JSON.parse(localStorage.getItem("user"));
  if (!userObject) {
    throw new Error("Could not fetch the user object.");
  }
  localStorage.setItem("user", JSON.stringify({ ...userObject, token }));
};
